'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentLaybuy1Asset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "#FF6C00",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.9413 28.5521L20.076 21.4174C22.4436 24.1109 22.3452 28.215 19.7784 30.7897V35.8327H12.4888V35.8316C12.4658 35.8316 12.4432 35.8319 12.4206 35.8322C12.4008 35.8325 12.381 35.8327 12.361 35.8327C8.26476 35.8327 4.94459 32.5126 4.94459 28.4163C4.94459 27.7806 5.0249 27.1641 5.17536 26.5747C5.31451 25.7659 4.66517 24.4661 4.00002 23.612C5.07468 23.7353 6.64484 23.6527 7.12674 23.1629C8.46839 21.8269 10.3191 21 12.3621 21C14.3146 21 16.0895 21.7568 17.413 22.9898L17.5228 23.1607L12.5363 28.1471C12.4243 28.2591 12.4243 28.4401 12.5363 28.5521C12.5917 28.6075 12.6653 28.6358 12.7388 28.6358C12.8123 28.6358 12.8858 28.6075 12.9413 28.5521ZM8.30548 24.9138C8.4661 25.286 8.83489 25.5462 9.26474 25.5462C9.84169 25.5462 10.3089 25.0778 10.3077 24.502C10.3077 23.9251 9.84053 23.4579 9.26361 23.4579C9.06906 23.4579 8.88804 23.5122 8.73194 23.605C8.73534 23.605 8.73873 23.6044 8.74213 23.6038C8.74552 23.6033 8.74892 23.6027 8.75231 23.6027C9.0645 23.6027 9.31792 23.8561 9.31792 24.1683C9.31792 24.4805 9.0645 24.7339 8.75231 24.7339C8.51475 24.7339 8.31225 24.588 8.22856 24.381C8.22856 24.3862 8.22782 24.391 8.22718 24.3957C8.22669 24.3992 8.22628 24.4025 8.22628 24.4059C8.22401 24.4319 8.22288 24.4579 8.22175 24.4839C8.22288 24.6355 8.25344 24.7803 8.30548 24.9138Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M72.1748 25.278C70.5492 25.278 69.2008 26.2192 68.6025 27.1174C68.1749 25.8979 67.1476 25.278 65.6714 25.278C64.1465 25.278 62.8897 26.0857 62.3671 26.6807C62.1374 26.2147 61.7947 25.8674 61.3602 25.6287C60.8715 25.3414 60.2561 25.2011 59.5401 25.2011C59.1454 25.2011 58.7662 25.2577 58.4112 25.3549C57.1419 25.5925 56.1205 26.3685 55.6204 27.1174C55.1928 25.8979 54.1657 25.278 52.6893 25.278C51.0637 25.278 49.7369 26.1977 49.2878 26.7973V25.5359H45.9936V35.8686H49.2878V29.1932C49.6305 28.7656 50.2505 28.1876 51.1271 28.1876C52.1328 28.1876 52.4971 28.7871 52.4971 29.5778V35.8675H55.7911V29.1932C56.0288 28.8753 56.445 28.476 57.0106 28.2905C57.1194 28.2588 57.2323 28.2328 57.3501 28.2102C57.4473 28.1955 57.548 28.1876 57.6531 28.1876C58.4428 28.1876 58.8467 28.5744 58.9745 29.1355V35.8686H62.2958V29.1615C62.6431 28.7373 63.254 28.1876 64.1103 28.1876C65.1159 28.1876 65.479 28.7871 65.479 29.5778V35.8675H68.7732V29.1932C69.0945 28.7656 69.7358 28.1876 70.6342 28.1876C71.6183 28.1876 72.0029 28.7871 72.0029 29.5778V35.8675H75.2766V28.381C75.2766 26.2633 74.0786 25.278 72.1748 25.278ZM45.1134 35.8686V25.5359H41.8194V32.2102C41.4348 32.7023 40.7921 33.2159 39.851 33.2159C38.7808 33.2159 38.1394 32.7883 38.1394 31.5473V25.5359H34.8441V32.8957C34.8441 34.7996 35.8927 36.1265 38.2458 36.1265C39.9789 36.1265 41.1769 35.3562 41.8182 34.6288V35.8686H45.1134ZM30.7864 29.8572C30.7864 28.5948 30.1235 28.1887 29.0748 28.1887C28.1122 28.1887 27.4707 28.7237 27.0851 29.1943V35.8697H23.7909V21.5992H27.0851V26.7984C27.7061 26.071 28.9256 25.2791 30.6575 25.2791C33.0105 25.2791 34.0806 26.605 34.0806 28.51V35.8697H30.7864V29.8572Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M78.8239 28.4195L78.456 27.7565C78.6265 27.6969 78.8159 27.5292 78.8159 27.2153C78.8159 26.8797 78.5885 26.6145 78.1881 26.6145H77.2843V28.4195H77.7498V27.8133H77.9879L78.291 28.4195H78.8239ZM78.1178 27.4074H77.7498V27.0204H78.1178C78.2423 27.0204 78.3424 27.0881 78.3424 27.2126C78.3424 27.3397 78.2423 27.4074 78.1178 27.4074Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M79.461 26.0391C79.0673 25.6454 78.5348 25.4254 77.9675 25.4254C77.4002 25.4254 76.8677 25.6454 76.474 26.0391C76.0804 26.4328 75.8604 26.9654 75.8604 27.5328C75.8604 28.1001 76.0804 28.6327 76.474 29.0264C76.8677 29.4201 77.4002 29.6401 77.9675 29.6401C78.5348 29.6401 79.0673 29.4201 79.461 29.0264C79.8546 28.6327 80.0746 28.1001 80.0746 27.5328C80.0862 26.977 79.8662 26.4444 79.461 26.0391ZM76.3929 27.5443C76.3929 28.4127 77.0993 29.1191 77.9675 29.1191C78.8357 29.1191 79.5421 28.4127 79.5421 27.5443C79.5421 26.6759 78.8357 25.9696 77.9675 25.9696C77.0993 25.9696 76.3929 26.6759 76.3929 27.5443Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpPaymentLaybuy1Asset = forwardRef(PaymentLaybuy1Asset);

export { VpPaymentLaybuy1Asset as default };
